import type { ReactNode } from 'react';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px;
  gap: 0;

  @media screen and (min-width: 1130px) {
    gap: 30px;
  }
`;

export const Main = styled.main<{
  children: ReactNode;
  paddingTop: boolean;
}>`
  width: ${({ theme }) => theme.contentMaxWidth};
  max-width: 100vw;
  margin-bottom: 30px;
  padding-top: ${({ paddingTop }) => (paddingTop ? '59px' : '0')};
`;

export const Aside = styled.aside`
  width: 400px;
  height: 100%;
  margin: 59px 0;
  display: none;

  > div {
    margin-bottom: 30px;
  }

  @media screen and (min-width: 1130px) {
    display: block;
  }
`;
